import Link from 'next/link'
import { type ComponentProps, forwardRef } from 'react'

import { appendLeadId } from '@/lib/attribution/leadId'
import { useLeadId } from '@/lib/attribution/useLeadId'

type TrackedLinkProps = ComponentProps<typeof Link>

/**
 * Drop-in replacement for `next/link` that re-appends the current `lead_id`
 * (from the in-memory AttributionProvider, captured off the URL on landing) to
 * the outgoing href. No-op when there is no `lead_id`, when the propagation
 * flag is off, or when the href is external. Forwards all `Link` props
 * (including `passHref` / `legacyBehavior`) and a ref unchanged. See WEB-903.
 */
export const TrackedLink = forwardRef<HTMLAnchorElement, TrackedLinkProps>(({ href, ...rest }, ref) => {
  const leadId = useLeadId()
  return <Link ref={ref} href={appendLeadId(href, leadId)} {...rest} />
})

TrackedLink.displayName = 'TrackedLink'
